// extracted by mini-css-extract-plugin
export var md = "_4x-4";
export var semantic = "_4x-5";
export var sm = "_4x-3";
export var text = "_4x-6";
export var toggleInput = "_4x-0";
export var toggleSwitch = "_4x-1";
export var xs = "_4x-2";